import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permissions from 'api/Apollo/permissions';
import { SCHEMAS_QUERY } from 'api/schemas/schemas-query-builder';
import { GET_SCHEMA_NAMES } from 'api/schemas/schema-names-query-builder';

import { mutation, buildVariables as buildUpdateSchemaVariables } from './update-schema-mutation-builder';

export default function useUpdateSchema(options = {}) {
  const [trackWithUser] = useTrackWithUser('schema_edited');
  const [executeMutation, response] = useMutation(mutation, {
    ...options,
    refetchQueries: [SCHEMAS_QUERY, { query: GET_SCHEMA_NAMES }],
    context: { permission: permissions.updateSchemas },
  });

  const updateSchemaMutation = ({ name, description, jsonSchema, schemaId, version }) => {
    return executeMutation({
      variables: {
        ...buildUpdateSchemaVariables({
          name,
          description,
          jsonSchema,
          schemaId,
          version,
        }),
      },
    }).then(response => {
      if (!response.errors) {
        trackWithUser({ id: schemaId, name, description, version });
      }
      return response;
    });
  };

  return [updateSchemaMutation, response];
}
